// apps/codeframe/src/motion/ease.ts
import type { EaseSpec } from '../store/types';
import { cubicBezierFn, springFn } from './mathAdapter';

const PRESETS: Record<string, [number, number, number, number]> = {
  easeIn: [0.42, 0, 1, 1],
  easeOut: [0, 0, 0.58, 1],
  easeInOut: [0.42, 0, 0.58, 1],
};

export function toEasingFn(ease: EaseSpec): (p: number) => number {
  if (ease === 'linear') return (p) => p;
  if (ease === 'step') return (p) => (p >= 1 ? 1 : 0);
  if (typeof ease === 'string') {
    const cp = PRESETS[ease];
    return cubicBezierFn(cp[0], cp[1], cp[2], cp[3]);
  }
  if ('bezier' in ease) return cubicBezierFn(...ease.bezier);
  return springFn(ease.spring);
}
